





















































import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'c-help-dlg'
})
export default class HelpDlg extends Vue {
  helpDlg: boolean = false

  applyHelp (): void {
    localStorage.setItem('stat-help-close', '1')
    this.helpDlg = false
  }

  mounted (): void {
    if (!localStorage.getItem('stat-help-close')) {
      this.helpDlg = true
    }
  }
}
